
// ********* Import CSS ***************** //

import '@styles/main.scss';
import "./summer-camp-2023.css";

// ********* Import Images ***************** //

// ** LOADING SPINNER - GCS Computer ** //
import "../assets/logos/gcs-logo-pink-comp-only.png";

// ** Camp Flyer ** //
import "../assets/flyers/girls-code-sav-summer-camp-2023-flyer.png";

// ** GCS Logo ** //
import "../assets/logos/gcs-logo-pink.png";

// ** Summer Camp Graphic ** //
import "../assets/summer-camp-2023/summer-camp-2023-graphic.png";

// ** GSU Photos ** //
import "../assets/summer-camp-2023/girls-walking-gsu-campus.jpg";
import "../assets/summer-camp-2023/gsu-campus.jpg";
import "../assets/summer-camp-2023/gsu-comp-sci-lab.jpg";
import "../assets/summer-camp-2023/gsu-science-center.jpg";
import "../assets/summer-camp-2023/girls-lunch-galley.jpg";

// ** Icebreakers ** //
import "../assets/summer-camp-2023/girls-playing-jenga.jpg";
import "../assets/summer-camp-2023/binary-bracelet.jpg";
import "../assets/summer-camp-2023/holding-binary-bracelet.jpg";
import "../assets/summer-camp-2023/girls-playing-spaghetti.jpg";

// ** Web Development ** //
import "../assets/summer-camp-2023/gcs-summer-camp-2023-15.jpeg";
import "../assets/summer-camp-2023/lesli-teaching.jpg";
import "../assets/summer-camp-2023/gcs-summer-camp-2023-21.jpeg";
import "../assets/summer-camp-2023/gcs-summer-camp-2023-7.jpeg";
import "../assets/summer-camp-2023/gcs-summer-camp-2023-web-dev-1.jpg";
import "../assets/summer-camp-2023/gcs-summer-camp-2023-web-dev-2.jpg";

// ** Fly Corps 1st Set ** //
import "../assets/summer-camp-2023/fly-corps-first-flight-board.jpg";
import "../assets/summer-camp-2023/fly-corps-plane-coming-in.jpg";
import "../assets/summer-camp-2023/fly-corps-girls-by-painting.jpg";

// ** Fly Corps 2nd Set ** //
import "../assets/summer-camp-2023/fly-corps-jake-talking-to-girls.jpg";
import "../assets/summer-camp-2023/fly-corps-app-screen.jpg";
import "../assets/summer-camp-2023/fly-corps-diya-laurie.png";

// ** Fly Corps 3rd Set ** //
import "../assets/summer-camp-2023/fly-corps-on-plane.jpg";
import "../assets/summer-camp-2023/fly-corps-in-plane-1.jpg";
import "../assets/summer-camp-2023/fly-corps-in-plane-2.jpg";
import "../assets/summer-camp-2023/fly-corps-in-plane-3.jpg";
import "../assets/summer-camp-2023/fly-corps-girls-in-line-plane.jpg";
import "../assets/summer-camp-2023/fly-corps-laurie-showing-plane.jpg";

// ** Girls Code Savannah & Creative Coast Team ** //
import "../assets/summer-camp-2023/lesli-with-girls.jpeg";
import "../assets/summer-camp-2023/jen-kait.jpeg";
import "../assets/summer-camp-2023/gcs-instructors.png";

// ** Camp Showcase ** //

import "../assets/summer-camp-2023/summer-camp-2023-showcase-1.jpg";
import "../assets/summer-camp-2023/summer-camp-2023-showcase-2.jpg";
import "../assets/summer-camp-2023/summer-camp-2023-showcase-3.jpg";
import "../assets/summer-camp-2023/summer-camp-2023-showcase-4.jpg";
import "../assets/summer-camp-2023/summer-camp-2023-showcase-5.jpeg";
import "../assets/summer-camp-2023/summer-camp-2023-showcase-6.jpeg";
import "../assets/summer-camp-2023/summer-camp-2023-showcase-7.jpeg";
import "../assets/summer-camp-2023/summer-camp-2023-showcase-8.jpg";
import "../assets/summer-camp-2023/summer-camp-2023-showcase-9.jpg";

// ** SUMMER CAMP 2023 - Camp Sponsors ** //
import "../assets/sponsor-logos/business-innovation-group.jpg";
import "../assets/sponsor-logos/city-of-savannah.png";
import "../assets/sponsor-logos/fly-corps.png";
import "../assets/sponsor-logos/howmet-aerospace.png";
import "../assets/sponsor-logos/howmet-womens-network.png";
import "../assets/sponsor-logos/sams-club-blue-bkgnd.png";

// ** Friends ** //

import "../assets/summer-camp-2023/gcs-summer-camp-2023-friends-1.jpeg";
import "../assets/summer-camp-2023/gcs-summer-camp-2023-friends-2.jpeg";
import "../assets/summer-camp-2023/gcs-summer-camp-2023-friends-3.jpeg";
import "../assets/summer-camp-2023/gcs-summer-camp-2023-friends-4.jpeg";
import "../assets/summer-camp-2023/gcs-summer-camp-2023-friends-5.jpg";
import "../assets/summer-camp-2023/summer-camp-2023-group-photo.jpg";

// ********* Add Top Nav & Footer *************** //

import '../nav-header-footer/nav-header-footer.js';
import '../nav-header-footer/nav-header-footer.css';

// *********** Loading Spinner *************** //

window.addEventListener('load', () => {
  const preloader = document.getElementById("preloader");
  if (preloader) {
    preloader.style.display = "block";
    setTimeout(() => {
      preloader.style.transition = "opacity 0.2s ease";
      preloader.style.opacity = 0;
      setTimeout(() => preloader.remove(), 200);
    }, 600);
  }
});